import { View } from "./View";

export const BalanceTable = () => {
  return <View />;
};
